import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-return",
  "use": "icon-return-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-return\">\n<path d=\"M91.5,44.6V13.2c-2.7-13.1-13-5.1-13-5.1L7.3,72.6c-15.7,11.4-1.1,20-1.1,20l70.2,64c14,10.9,15.1-5.7,15.1-5.7v-29.1\n\tc71.3-23.4,100.4,70.3,100.4,70.3c2.7,5.1,4.3,0,4.3,0C223.8,51.5,91.5,44.6,91.5,44.6L91.5,44.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/return.svg
// module id = FZdh
// module chunks = 27